export default __webpack_public_path__ + "static/media/img-cwa-6-mobile.770d64e8.png";